export const STATUS_SELECT_TYPES = Object.freeze({
	PENDIENTE: 'Pendiente',
	COMPLETADO: 'Completado',
	PENDING_SUPERVISION: 'PENDING_SUPERVISION', // All in pending to change status or pending to execute
	SUSPENDED: 'SUSPENDED', // All suspended
	PENDING_VALIDATION: 'PENDING_VALIDATION', // At least one in pending to validate
	COMPLETED: 'COMPLETED', // All in accomplished, not accomplished or suspended
});
